<script>
  import HeadshotCircle from '@/components/headshot-circle.vue'

  export default {
    name: 'hours-card',
    components: {
      HeadshotCircle
    },
    data: () => ({
      members: [
        {
          id: 5,
          name: 'Debbie Y. Smith, Ed.D.',
          title: 'Board President',
          headshot: 'https://media.eipl.org/site/images/pages/about/board/dsmith.jpg'
        },
        {
          id: 3,
          name: 'Jackie S. Flamio',
          title: 'Board Vice President',
          headshot: 'https://media.eipl.org/site/images/pages/about/board/flamio.jpg'
        },
        {
          id: 1,
          name: 'Stephen Foray',
          title: 'Board Member',
          headshot: 'https://media.eipl.org/site/images/pages/about/board/foray.jpg'
        },
        {
          id: 2,
          name: 'Joseph Gabriel, AIA',
          title: 'Board Member',
          headshot: 'https://media.eipl.org/site/images/pages/about/board/boardGabriel.jpg'
        },
        {
          id: 4,
          name: 'Victor C. Gremli, Jr., D.C.',
          title: 'Board Member',
          headshot: 'https://media.eipl.org/site/images/pages/about/board/gremli.jpg'
        }
      ]
    })
  }
</script>

<template>
  <v-card flat max-width="1000" width="100%">
    <!-- <v-card-title class="text-h3 primary--text text-center justify-center"><router-link :to="{ name: 'board-of-trustees' }">Board of Trustees</router-link></v-card-title> -->
    <v-card-text class="d-flex flex-wrap align-center primary--text font-weight-bold pa-8">
      <v-sheet color="transparent" width="100%" class="d-flex flex-wrap align-center justify-space-around">
        <headshot-circle :headshotData="members[0]" size="sm"></headshot-circle>
        <headshot-circle :headshotData="members[1]" size="sm"></headshot-circle>
      </v-sheet>
      <v-sheet color="transparent" width="100%" class="d-flex flex-wrap align-center justify-space-around">
        <headshot-circle :headshotData="members[2]" size="sm"></headshot-circle>
        <headshot-circle :headshotData="members[3]" size="sm"></headshot-circle>
        <headshot-circle :headshotData="members[4]" size="sm"></headshot-circle>
      </v-sheet>
    </v-card-text>
  </v-card>
</template>

<style scoped></style>
